function initSite() {
  // ── FEATURED PRODUCTS SLIDER ──────────────────────────────────────
  (function(){
    const track   = document.getElementById('fpTrack');
    const btnPrev = document.getElementById('fpPrev');
    const btnNext = document.getElementById('fpNext');
    if (!track || !btnPrev || !btnNext) return;
    let current = 0;

    function getVisible() {
      const w = window.innerWidth;
      if (w >= 1280) return 4;
      if (w >= 900)  return 3;
      if (w >= 600)  return 2;
      return 1;
    }

    function totalCards() { return track.querySelectorAll('.product-card').length; }

    function update() {
      const visible = getVisible();
      const max     = totalCards() - visible;
      current       = Math.max(0, Math.min(current, max));
      const cardW   = track.querySelector('.product-card').offsetWidth;
      track.style.transform = `translateX(-${current * cardW}px)`;
      btnPrev.disabled = current === 0;
      btnNext.disabled = current >= max;
      btnPrev.style.opacity = current === 0 ? '0.4' : '1';
      btnNext.style.opacity = current >= max ? '0.4' : '1';
    }

    btnNext.addEventListener('click', () => { current++; update(); });
    btnPrev.addEventListener('click', () => { current--; update(); });
    window.addEventListener('resize', () => { current = 0; update(); });
    update();
  })();

  // ── VIDEO MODAL ───────────────────────────────────────────────────
  (function(){
    const modal    = document.getElementById('videoModal');
    const iframe   = document.getElementById('videoIframe');
    const backdrop = document.getElementById('videoBackdrop');
    const closeBtn = document.getElementById('videoClose');
    if (!modal || !iframe || !backdrop || !closeBtn) return;

    function openModal(src) {
      if (!src) return;
      const url = src.includes('autoplay') ? src : `${src}${src.includes('?') ? '&' : '?'}autoplay=1`;
      iframe.src = url;
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      iframe.src = '';
      document.body.style.overflow = '';
    }

    document.querySelectorAll('.podcast-play[data-video]').forEach(btn => {
      btn.addEventListener('click', () => openModal(btn.dataset.video));
    });

    document.querySelectorAll('[data-video]').forEach(el => {
      if (!el.classList.contains('podcast-play')) {
        el.addEventListener('click', () => openModal(el.dataset.video));
      }
    });

    backdrop.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeModal();
    });
  })();
}

/* Auto-init in Shopify (sections are server-rendered, no fetch needed) */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSite);
} else {
  initSite();
}
